import styled from 'styled-components';

export const ModalOverlay = styled.div`
  .hefesto-modal__header {
    margin-bottom: 12px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #495961;
      font-weight: 400;
    }
  }
`;

export const ChooseNewOrReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  font-size: 16px;

  & strong {
    font-weight: 700;
  }
`;
